





























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import {
  AppBrowserTarget,
  isMobileApp,
  openUrl
} from "@/shared/mobileHelper";

@Component({
  components: {}
})
export default class AvidiaForms extends Vue {
  AllegacyResourcesUrl = "https://www.allegacy.org/disclosures/";

  clickLink (event) {
    if (isMobileApp()) {
      openUrl(event.currentTarget.href, AppBrowserTarget.system);
    } else window.open(event.currentTarget.href, event.currentTarget.target);
  }
}
